import { Trans } from "@lingui/react";
import { Alert } from "@warp-ds/elements/react/alert";

export const InactiveAlert = () => {
  return (
    <Alert className="mt-24" variant="negative" show>
      <h3 className="t4 -mt-2">
        <Trans
          id="itemPageLayout.adinfo.inactive.title"
          message="This ad is no longer available"
          comment="Heading of the alert shown on inactive ads"
        />
      </h3>
      <p>
        <Trans
          id="itemPageLayout.adinfo.inactive.cannotcontact"
          message="The seller can’t be contacted about this vehicle."
          comment="Description in the alert shown on inactive ads"
        />
      </p>
    </Alert>
  );
};
